import React from 'react'

export const Context = React.createContext(null)  // OP: FixIt

export default Context
